import React from 'react';
import { StackMain } from './Stack';

export default React.memo(React.forwardRef(StackMain));
